import { AfterContentInit, AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef } from "@angular/core";
import { colorContrast } from '@ep-om/utils/styleUtils';
import ColorHash from 'color-hash';
import { TestObject } from "protractor/built/driverProviders";

export interface TagComponentOptions {
  id?: string;
  showTooltip?: boolean,
  label: string,
  showLabel?: boolean,
  showDeleteIcon?: boolean,
  minWidth?: string,
  minHeight?: string,
  icon?: TemplateRef<any>,
  active?: boolean,
}
@Component({
  selector: 'tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent implements OnInit {
  @Input() id?: string;
  @Input() showTooltip: boolean;
  @Input() label: string;
  @Input() showLabel: boolean;
  @Input() showDeleteIcon: boolean;
  @Input() minWidth: string;
  @Input() minHeight: string;
  @Input() icon: TemplateRef<any>;
  @Input() active: boolean;
  @Input() tooltipPlacement: string | string[];
  @Output() iconClicked = new EventEmitter<string>();
  style: { [key: string]: string | number } = {}
  colorHash: ColorHash;

  constructor() {
    this.colorHash = new ColorHash();
  }

  
  ngOnInit(): void {
    const background = this.colorHash.hex(this.label? this.label : '');
    const color = colorContrast(background);
    this.style = {
      background,
      color,
      'margin': '0px',
      'min-width': this.minWidth || '28px',
      'min-height': this.minHeight || '14px',
    }
    if (typeof this.showLabel !== 'boolean') {
      this.showLabel = true
    }
    if (typeof this.active !== 'boolean') {
      this.active = false;
    }
    if (typeof this.showTooltip !== 'boolean') {
      this.showTooltip = false;
    }
    if (this.tooltipPlacement === undefined || this.tooltipPlacement === null) {
      this.tooltipPlacement = 'bottom';
    }
  }

  onIconClicked(label: string) {    
    this.iconClicked.emit(label);
  }

}
